import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resolveAppLanguage, isLaunchUiEnglishOnly } from '@shared/resolveAppLanguage.mjs';

import en from '@shared/locales/en.json';
import de from '@shared/locales/de.json';
import fr from '@shared/locales/fr.json';
import it from '@shared/locales/it.json';
import es from '@shared/locales/es.json';

const STORAGE_KEY = 'fcp_app_language';

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
  es: { translation: es },
};

function readDeviceTag() {
  if (typeof navigator === 'undefined') return null;
  return navigator.language || null;
}

function readStoredLanguage() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

const initialLanguage = resolveAppLanguage({
  stored: readStoredLanguage(),
  deviceTag: readDeviceTag(),
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLanguage;
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: 'v4',
});

export async function setAppLanguage(language) {
  const resolved = resolveAppLanguage({
    stored: language,
    deviceTag: readDeviceTag(),
  });
  await i18n.changeLanguage(resolved);
  if (!isLaunchUiEnglishOnly()) {
    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch {
      // ignore
    }
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = resolved;
  }
  return resolved;
}

export async function applyServerLanguagePreference(serverLanguage) {
  return setAppLanguage(serverLanguage);
}

export { useTranslation } from 'react-i18next';

export default i18n;
